import React from 'react';

// SMS consent box (v2.1 AD5). UNCHECKED by default: the parent opts in by
// ticking it (PO decision 2026-10-01 — carriers rejected the A2P campaign
// while the box was pre-checked). The disclosure text is the carrier-required
// wording; STOP always works. /sms shows this same box to carrier reviewers.
const SmsConsent = ({ checked, onChange, color = '#1A5FD4' }) => (
  <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '12.5px', color: '#5A6070', lineHeight: '1.5', cursor: 'pointer' }}>
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} style={{ marginTop: '3px', accentColor: color }} aria-label="Text me team updates" />
    <span>
      <strong style={{ color: '#0D1117' }}>Text me team updates.</strong> I agree to receive HoopHero Team Updates texts at the number above: game and practice reminders, schedule changes, payment reminders, and messages from the coach. Message frequency varies. Message and data rates may apply. Reply STOP to opt out, HELP for help. Consent is not required to register.
    </span>
  </label>
);

export default SmsConsent;

// X-4: what the registration request says about SMS consent. It reflects only
// what was actually rendered: when the box (and its disclosure) is hidden we
// send an explicit opt-out, whatever the box state. The server makes
// the final call (it also requires SMS to be enabled).
export const smsConsentPayload = (shown, optIn) => ({
  smsOptIn: shown ? optIn === true : false,
  smsDisclosureShown: !!shown,
});
